import { render, staticRenderFns } from "./loggedLayout.vue?vue&type=template&id=4c7da637&"
import script from "./loggedLayout.vue?vue&type=script&lang=js&"
export * from "./loggedLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports